import script from "./FooterFbochasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterFbochasComponent.vue?vue&type=script&setup=true&lang=js"

import "./FooterFbochasComponent.vue?vue&type=style&index=0&id=03cccad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03cccad8"]])

export default __exports__